import { useRef, useEffect, useCallback, useState, useContext } from "react";
import ProductDetailUI from "./ProductDetailUI";
import { productService } from "@services/ProductService";
import { IProduct } from "src/types/global";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalAlertContext } from "@providers/GlobalAlertProvider";
import { debounce } from "lodash";
const ProductDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState<IProduct>({
    id: -1,
    reference: "N/A",
    description: "...",
    price: "0",
    status: 1
  });
  const [controllStatus, setControllStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const {
    setGlobalAlertMessage,
    setGlobalAlertSeverity,
    showGlobalAlert
  } = useContext(GlobalAlertContext);
  const debouncedStatus = useRef(debounce((status: boolean, oldProduct: IProduct) => changeStatus(status, oldProduct), 600)).current;
  const changeStatus = async (status: boolean, oldProduct: IProduct) => {
    try {
      const newProduct = {
        ...oldProduct,
        status: status ? 0 : 1
      };
      await productService.put(newProduct);
      setProduct(newProduct);
    } catch (error) {}
  };
  const handleChangeStatus = (status: boolean) => {
    setControllStatus(status);
    debouncedStatus(status, product);
  };
  const handleDelete = async () => {
    try {
      setGlobalAlertSeverity("success");
      setGlobalAlertMessage("!Listo! El producto ha sido eliminado correctamente.");
      setIsDeleting(true);
      setShowDialogDelete(false);
      await productService.remove(product.id);
      navigate("/productos", {
        state: {
          showAlert: true
        }
      });
      showGlobalAlert();
    } catch (error) {
      setShowError(true);
    } finally {
      setIsDeleting(false);
    }
  };
  const getProduct = useCallback(async (id: number, withState: boolean = false) => {
    try {
      if (product.id === id) {
        return;
      }
      if (!withState) {
        setIsLoading(true);
      }
      const res = await productService.get(id);
      const productDB = res.data;
      setProduct(productDB);
      setControllStatus(productDB.status === 0);
    } catch (error) {
      setGlobalAlertSeverity("error");
      setGlobalAlertMessage("El producto no existe");
      navigate("/productos", {
        state: {
          showAlert: true
        }
      });
      setTimeout(() => {
        showGlobalAlert();
      }, 300);
    } finally {
      setIsLoading(false);
    }
  }, [navigate, setGlobalAlertSeverity, setGlobalAlertMessage, showGlobalAlert, product.id]);
  useEffect(() => {
    const id = Number(location.pathname.split("/").reverse()[0]);
    const routeState: IProduct = location.state;
    if (id === routeState?.id) {
      setProduct(routeState);
      setControllStatus(routeState.status === 0);
      return setIsLoading(false);
    }
    getProduct(id, id === routeState?.id);
  }, [getProduct, location]);
  useEffect(() => {
    return () => {
      debouncedStatus.cancel();
    };
  }, [debouncedStatus]);
  return <ProductDetailUI id={product.id} name={product.description} reference={product.reference} price={product.price} status={product.status} controllStatus={controllStatus} isLoading={isLoading} showError={showError} closeError={() => setShowError(false)} isDeleting={isDeleting} showDialog={showDialogDelete} handleConfirmDialog={handleDelete} handleOpenDialog={() => setShowDialogDelete(true)} handleCloseDialog={() => setShowDialogDelete(false)} handleChangeStatus={handleChangeStatus} />;
};
export default ProductDetail;